import { Link } from "react-router-dom";
import Layout from "../../components/Layout";

const Coliseum: React.FC = () => {
  return (
    <Layout>
      <div>
        <p><Link to="/">top</Link></p>
        コロシアム
      </div>
    </Layout>
  );
}

export default Coliseum;
